module.exports = __webpack_public_path__ + "img/scatter_freespin.d27877b6.png";